import React, { useEffect, useCallback, useState} from 'react';
import {SYNCED} from 'constants/connection-status-types.js';
import {
    makeInstrumentRack,
    copyAllSteps,
    makeEffectRack,
    savePreset,
    deleteLocks,
    deleteAutomations,
    transcribeTrack,
    extractStems,
    freezePatterns
} from './trackRightClickActions.js';
import {connect} from 'react-redux';

const TrackContextMenu = ({track, dropdownPos, setDropdownPos, connectionStatus}) => { 
    useEffect(() => {
        if (dropdownPos) {
            window.addEventListener("mousedown", hideContextMenu);
        } else {
            window.removeEventListener("mousedown", hideContextMenu);
        }
    }, [setDropdownPos, dropdownPos]);

    const hideContextMenu = useCallback(() => {
        setDropdownPos(undefined);
    }, [setDropdownPos]);

    const executeAndClear = useCallback((fn) => {
        fn(track);
        hideContextMenu();
    }, [track, setDropdownPos]);

    const sendTrack = useCallback((track) => {
        track.sequencerEngine.clockSync.transferTrack(track);
    }, [track]);

    if (!dropdownPos) { return []; };
    return (
        <div style={{top: dropdownPos.y, left: dropdownPos.x}} className="track-context-menu context-menu">
          {connectionStatus === SYNCED &&
           <div onMouseDown={() => executeAndClear(sendTrack)}
                className="menu-item">
             Send to Peer
           </div>}
          <div
            onMouseDown={() => executeAndClear(makeInstrumentRack)}
            className="menu-item">
            Make Instrument Rack
          </div>
          <div
            onMouseDown={() => executeAndClear(savePreset)}
            className="menu-item">
            Save Preset
          </div>
          <div
            onMouseDown={() => executeAndClear(copyAllSteps)}
            className="menu-item">
            Copy All Steps 
          </div>
          <div
            onMouseDown={() => executeAndClear(transcribeTrack)}
            className="menu-item">
            Transcribe
          </div>
          <div
            onMouseDown={() => executeAndClear(extractStems)}
            className="menu-item">
            Extract Stems
          </div>
          <div className="menu-item" onMouseDown={() => executeAndClear(deleteLocks)}>
            Delete Locks
          </div>
          <div className="menu-item" onMouseDown={() => executeAndClear(deleteAutomations)}>
            Delete Automations
          </div>
          <div className="menu-item" onMouseDown={() => executeAndClear(makeEffectRack)}>
            Make Effect Rack
          </div>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
      connectionStatus: state.clock.connectionStatus
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackContextMenu);
